<template>
  <div class="header__wrapper">
    <div class="header__desktop">
      <div class="header__desktop-image">
        <img src="@/assets/logo.png" />
      </div>
      <div class="header__desktop-nav">
        <ul>
          <li
            class="header__desktop-nav-item"
            v-for="(item, index) in items"
            :key="index"
          >
            <router-link :to="item.to">
              {{ item.title }}
            </router-link>
          </li>
        </ul>
      </div>
      <div class="header__desktop-socials">
        <div class="header__desktop-socials-icon">
          <a
            target="_blank"
            href="https://www.facebook.com/evabuchwaldcollection"
          >
            <fa-icon :icon="['fab', 'facebook-f']" size="xs" />
          </a>
        </div>
      </div>
    </div>
    <div class="header__mobile">
      <div class="header__mobile-logo">
        <h3>Eva & Thomas</h3>
      </div>
      <div class="header__mobile-burger">
        <fa-icon
          @click="mobileHeaderActive = !mobileHeaderActive"
          :icon="['fas', mobileHeaderActive ? 'times' : 'bars']"
          size="sm"
        />
      </div>
      <transition name="list">
        <div v-if="mobileHeaderActive" class="header__mobile-items">
          <ul>
            <li v-for="(item, index) in items" :key="index">
              <router-link :to="item.to">
                {{ item.title }}
              </router-link>
            </li>
          </ul>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import { allCategories } from '@/services/api/category.js'

export default {
  data() {
    return {
      mobileHeaderActive: false,
      items: [
        {
          title: 'Start',
          to: { name: 'Home' }
        },
        {
          title: 'Contact',
          to: { name: 'Contact' }
        }
      ]
    }
  },
  mounted() {
    allCategories().then(response => {
      response.categories.forEach(category => {
        this.items.push({
          title: category.name,
          to: {
            name: 'CategoryProducts',
            params: { id: category.id }
          }
        })
      })
    })
  }
}
</script>

<style lang="sass">
.header
  &__desktop
    @apply hidden
  &__mobile
    @apply h-16 bg-white w-full fixed flex justify-between items-center z-10
    &-logo
      @apply pl-4
    &-items
      color: $main-bg-color
      @apply bg-white w-full mt-16 top-0 h-auto fixed pl-4 flex items-center
    &-burger
      @apply pr-4

@screen md
  .header__mobile
    @apply hidden
  .header__desktop
    background: $accent-color
    @apply h-screen w-full flex flex-col justify-center
    &-image
      @apply flex justify-center mb-8
    &-nav
      @apply w-full px-8 text-2xl italic text-center
      &-item
        @apply py-2 text-gray-400 cursor-pointer relative
        &:hover
          @apply text-white
        &:hover::after
          @apply w-1/2 bg-white
        &::after
          content: ''
          height: 1px
          transition: width .5s ease, background-color .5s ease
          @apply block m-auto w-0 bg-transparent
    &-socials
      @apply w-full mt-8 flex justify-center
      &-icon
        border: 1px solid $accent-color
        color: #1877F2
        @apply bg-white px-4 rounded-full mx-1 cursor-pointer
        transition: all 0.2s ease-in
        &:hover
          background: $accent-color
          @apply text-white border-white


.list-enter,
.list-leave-to
  height: 0

.list-enter-active,
.list-leave-active
  transition: height 0.3s ease-in-out
  overflow: hidden
</style>
